import { MessageSquare } from 'lucide-react';
import { useT } from '../I18nContext';

/**
 * Empty-state for the chat surface - shown when there are no
 * conversation turns yet. Rendered by <MessageStream/> when
 * the conversation cache is empty AND no send is in flight.
 *
 * Kept intentionally short - the composer below is the
 * primary thing the user is meant to engage with. This
 * placeholder is just so the area doesn't read as "broken"
 * before they've typed anything.
 */
export function ChatPlaceholder() {
  const t = useT();
  return (
    <div className="dashboard-chat-placeholder">
      <div className="dashboard-chat-placeholder-icon">
        <MessageSquare size={28} />
      </div>
      <h2 className="dashboard-chat-placeholder-title">{t('chat_placeholder.title')}</h2>
      <p className="dashboard-chat-placeholder-sub">
        {t('chat_placeholder.subtitle')}
      </p>
    </div>
  );
}
